module.exports = [
	{
		"name": "Quadrant 1",
		"index": 0,
		"id": "0",
		"growth": "high",
		"income": "low"
	},
	{
		"name": "Quadrant 2",
		"index": 1,
		"id": "1",
		"growth": "high",
		"income": "high"
	},
	{
		"name": "Quadrant 3",
		"index": 2,
		"id": "2",
		"growth": "low",
		"income": "low"
	},
	{
		"name": "Quadrant 4",
		"index": 3,
		"id": "3",
		"growth": "low",
		"income": "high"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/nav-links-strip/nav-links-list.json
// module id = 101
// module chunks = 0